import { render, staticRenderFns } from "./CompanyAccessDescriptionPage.vue?vue&type=template&id=de50ec94&scoped=true&lang=pug&"
import script from "./CompanyAccessDescriptionPage.vue?vue&type=script&lang=js&"
export * from "./CompanyAccessDescriptionPage.vue?vue&type=script&lang=js&"
import style0 from "./CompanyAccessDescriptionPage.vue?vue&type=style&index=0&id=de50ec94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de50ec94",
  null
  
)

export default component.exports